/**
 * 名师详情
 */

import axios from '../utils/http';


/*
 * 课件列表
 * @param userid, pageno, count
 */
const coursewareList = params => {
  return axios.request({
    data: {
      ...params
    },
    method: 'post',
    url: '/v7/teacher/coursewarelist2'
  })
}

// 名师详情 @params userid
const teacherInfo = params => {
  return axios.request({
    data: {
      ...params
    },
    method: 'post',
    url: '/v7/teacher/details2'
  })
}


export default {
  coursewareList,
  teacherInfo
};
